import {View} from 'MWC';
import tpl from '../templates/HowToBlockNew.jsx';

export default class extends View {
    template = tpl;

    constructor(props) {
        super(props);
        this.state = {
            ui: this.uiStates.INITIAL
        };
        return this;
    }
}
